export default [
    {
        path: "/omp",
        name: "omp__root__",
        redirect: {
            name: "omp-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "omp",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "omp-index",
                component: () => import("@/views/omp/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/omp/titan",
        name: "titan",
        meta: {
            title: "全局设置",
            icon: "atom",
            parent: "omp",
            permission: "omp_manage_config",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/titan/titanconf",
        children: [
            {
                path: "announcement",
                name: "announcement",
                component: () => import("@/views/cms/misc/announcement"),
                meta: {
                    title: "公告管理",
                    icon: "announcement",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/omp/aigrow",
        name: "aigrow",
        meta: {
            title: "AI Grow",
            icon: "aigrow",
            parent: "omp",
            permission: "cms_manage_aigrow",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/aigrow/albums",
        children: [
            {
                path: "albums",
                name: "aigrow-albums",
                component: () => import("@/views/omp/aigrow/albums"),
                meta: {
                    title: "相册管理",
                    icon: "album",
                    affix: false,
                },
            },
            {
                path: "task",
                name: "ripen-task-replay",
                component: () => import("@/views/omp/aigrow/task"),
                // hidden: true,
                meta: {
                    title: "任务队列",
                    icon: "todo",
                    affix: false,
                },
            },
            {
                path: "stat",
                name: "ripen-task-stat",
                component: () => import("@/views/omp/aigrow/stat"),
                // hidden: true,
                meta: {
                    title: "处理统计",
                    icon: "history",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/omp/device",
        name: "omp-device",
        meta: {
            title: "设备管理",
            icon: "device",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "omp-device-sim",
        },
        children: [
            {
                path: "sim",
                name: "omp-device-sim",
                component: () => import("@/views/omp/device/sim.vue"),
                meta: {
                    title: "流量管理",
                    icon: "sim",
                    permission: "manage_sim_list",
                },
            },
        ],
    },
    {
        path: "/omp/msg",
        name: "omp-msg",
        meta: {
            title: "消息管理",
            icon: "message",
            parent: "omp",
            permission: "omp_manage_message",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "omp-msg",
        },
        children: [
            {
                path: "message",
                name: "omp-msg-message",
                component: () => import("@/views/omp/msg/message/index.vue"),
                meta: {
                    title: "私信管理",
                    icon: "private",
                },
            },
            {
                path: "email",
                name: "omp-msg-email",
                component: () => import("@/views/omp/msg/email/index.vue"),
                meta: {
                    title: "邮件管理",
                    icon: "email",
                },
            },

            {
                path: "email/detail",
                name: "omp-msg-email-detail",
                hidden: true,
                component: () => import("@/views/omp/msg/email/email_detail"),
                meta: {
                    title: "发送邮件",
                    affix: false,
                },
            },
            {
                path: "wxmsg",
                name: "omp-msg-wxmsg",
                component: () => import("@/views/omp/msg/wxmsg/index.vue"),
                meta: {
                    title: "微信管理",
                    icon: "wxmsg",
                },
            },
            {
                path: "phmsg",
                name: "omp-msg-phmsg",
                component: () => import("@/views/omp/msg/phmsg/index.vue"),
                meta: {
                    title: "短信管理",
                    icon: "phmsg",
                },
            },
        ],
    },
    {
        path: "/omp/enterprise",
        name: "omp-enterprise",
        meta: {
            title: "企业管理",
            icon: "enterprise",
            parent: "omp",
            permission: "omp_manage_enterprise",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "omp-enterprise",
        },
        children: [
            {
                path: "organization",
                name: "omp-enterprise-organization",
                component: () => import("@/views/omp/enterprise/organization.vue"),
                meta: {
                    title: "全部企业",
                    icon: "organization",
                },
            },
        ],
    },
    {
        path: "/omp/account",
        name: "omp-account",
        meta: {
            title: "账户管理",
            icon: "user",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "omp-account-super",
        },
        children: [
            {
                path: "user",
                name: "omp-account-user",
                component: () => import("@/views/omp/account/user.vue"),
                meta: {
                    title: "全部账号",
                    icon: "users",
                    permission: "omp_manage_account",
                },
            },
            {
                path: "super",
                name: "omp-account-super",
                component: () => import("@/views/omp/account/super.vue"),
                meta: {
                    title: "特权账号",
                    icon: "protection",
                    permission: "omp_manage_super",
                },
            },
        ],
    },
    {
        path: "/omp/system",
        name: "omp-system",
        meta: {
            title: "系统管理",
            icon: "system",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "omp-action-log",
        },
        children: [
            {
                path: "action-log",
                name: "omp-action-log",
                component: () => import("@/views/omp/system/action_log.vue"),
                meta: {
                    title: "用户日志",
                    icon: "log",
                    permission: "manage_system_action_log",
                },
            },
            {
                path: "upload-log",
                name: "omp-upload-log",
                component: () => import("@/views/omp/system/upload_log.vue"),
                meta: {
                    title: "上传日志",
                    icon: "upload",
                    permission: "manage_system_upload_log",
                },
            },
            {
                path: "sms-log",
                name: "omp-sms-log",
                component: () => import("@/views/omp/system/sms_log.vue"),
                meta: {
                    title: "短信日志",
                    icon: "sms",
                    permission: "manage_system_sms_log",
                },
            },
        ],
    },
];
